import React from "react";
import styled from "styled-components";
import { Comment as CommentFragment } from "@sonder/ui/source/styled/fragments/Comment";
import { colors } from "@sonder/ui/source/styled/theme";

const StyledLastReadAt = styled(CommentFragment)`
  align-items: center;
  color: ${colors.greenDark};
  font-size: 0.75rem;
`;

const StyledDivider = styled.span`
  border-top: 1px solid ${colors.greenDark};
  margin-left: 0.5rem;
  flex: 1 0 auto;
`;

interface LastViewedAtProps {
  children?: React.ReactNode;
}

export const LastViewedAt = ({ children = null }: LastViewedAtProps) => {
  return (
    <StyledLastReadAt>
      <span>{children}</span>
      <StyledDivider />
    </StyledLastReadAt>
  );
};
